import React, { FC } from 'react'
import { InjectedFormProps, reduxForm, Field } from 'redux-form'
import { Button, Col, Form, Row } from 'antd'
import { useTranslation } from 'react-i18next'
import { debounce } from 'lodash'
import { PlusOutlined, SearchOutlined } from '@ant-design/icons'

// utils
import { FORM, PROTECTION_INTERVAL_FOR_FILTER } from '../../../utils/enums'
import { validationString } from '../../../utils/helper'

// atoms
import InputField from '../../../atoms/InputField'

type ComponentProps = {
	resetFilter: () => void
	openCreateFormModal: any
}

interface IUserPermissionFilter {
	search: string
}

type Props = InjectedFormProps<IUserPermissionFilter, ComponentProps> & ComponentProps

const fixLength100 = validationString(100)

const FormDocsPageFilter: FC<Props> = (props) => {
	const { handleSubmit, resetFilter, openCreateFormModal } = props

	const { t } = useTranslation()

	return (
		<Form layout='horizontal' onSubmitCapture={handleSubmit} className={'pt-0'}>
			<Row className={'flex flex-wrap'}>
				<Col span={4}>
					<Field
						component={InputField as any}
						className={'h-10 p-0 m-0 form-table-search'}
						size={'large'}
						placeholder={t('loc:Search form ...')}
						name={'search'}
						validate={fixLength100}
						prefix={<SearchOutlined />}
						search
					/>
				</Col>
				<Col span={4} className={'pl-5'}>
					<Button
						className={'button-border-primary rounded h-10 ml-2'}
						onClick={() => {
							resetFilter()
							props.reset()
						}}
					>
						{t('loc:Reset filters')}
					</Button>
				</Col>
				<Col span={4} offset={12} className={'pl-5 flex justify-end'}>
					<Button className={'rounded h-10 ml-2 flex items-center'} type='primary' icon={<PlusOutlined />} onClick={openCreateFormModal}>
						{t('loc:Create form')}
					</Button>
				</Col>
			</Row>
		</Form>
	)
}

const form = reduxForm<IUserPermissionFilter, ComponentProps>({
	form: FORM.FORM_DOCS_PAGE_FILTER,
	forceUnregisterOnUnmount: true,
	touchOnChange: true,
	onChange: debounce((_values, _dispatch, { submit, anyTouched }) => {
		if (anyTouched) {
			submit()
		}
	}, PROTECTION_INTERVAL_FOR_FILTER),
	destroyOnUnmount: true
})(FormDocsPageFilter)

export default form
